// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "rescript/lib/es6/js_math.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as Motion$LiteracyplanetTupperware from "./Motion.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as V3QuestionsApi$LiteracyplanetTupperware from "./V3QuestionsApi.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3StylePreferences$LiteracyplanetTupperware from "./V3StylePreferences.res.mjs";

function PilotQuestionVisible$Transition(props) {
  return React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
              variants: {
                offscreen: {
                  scale: 0.6,
                  y: 150
                },
                onscreen: {
                  scale: 1,
                  y: 0,
                  transition: {
                    type: "spring",
                    bounce: 0.4,
                    duration: 1
                  }
                }
              },
              className: TailwindMerge.twMerge("relative", props.isInView ? "z-20" : "z-10"),
              children: Caml_option.some(props.children)
            });
}

var Transition = {
  make: PilotQuestionVisible$Transition
};

function PilotQuestionVisible$InViewTransition(props) {
  var domRef = React.useRef(null);
  var isInView = React$1.useInView(domRef, {
        amount: "all"
      });
  return React.createElement(Motion$LiteracyplanetTupperware.Inview.make, {
              children: React.createElement(PilotQuestionVisible$Transition, {
                    isInView: isInView,
                    children: props.children
                  })
            });
}

var InViewTransition = {
  make: PilotQuestionVisible$InViewTransition
};

var scroll = (function(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

function PilotQuestionVisible$ScrollableQuestion(props) {
  var children = props.children;
  var questionIndex = props.questionIndex;
  var domRef = React.useRef(null);
  var isInView = React$1.useInView(domRef, {
        amount: "all"
      });
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onChangeQuestion = match.onChangeQuestion;
  var currentQuestionIndex = match.currentQuestionIndex;
  React.useEffect((function (param) {
          if (currentQuestionIndex === questionIndex && !isInView) {
            scroll(domRef.current);
          }
          
        }), [currentQuestionIndex]);
  React.useEffect((function (param) {
          if (isInView && questionIndex !== currentQuestionIndex) {
            Curry._1(onChangeQuestion, questionIndex);
          }
          
        }), [isInView]);
  return React.createElement("div", {
              ref: Caml_option.some(domRef),
              className: props.className
            }, props.questionZoomInTransition ? React.createElement(Motion$LiteracyplanetTupperware.Inview.make, {
                    children: React.createElement(PilotQuestionVisible$Transition, {
                          isInView: isInView,
                          children: children
                        })
                  }) : children);
}

var ScrollableQuestion = {
  make: PilotQuestionVisible$ScrollableQuestion
};

function PilotQuestionVisible$Content(props) {
  var match = V3StylePreferences$LiteracyplanetTupperware.usePrefs();
  var progressRetract = match.progressRetract;
  return React.createElement("div", {
              className: "pt-5"
            }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                  id: "stemContainerQuestion-" + String(props.questionIndex),
                  className: "",
                  children: null
                }), React.createElement("div", {
                  className: TailwindMerge.twMerge(match.floatingStem ? (
                          progressRetract ? "max-h-[85vh]" : "max-h-[78vh]"
                        ) : (
                          progressRetract ? "max-h-[92vh]" : "max-h-[88vh]"
                        ), "pilot-question-container")
                }, props.children));
}

var Content = {
  make: PilotQuestionVisible$Content
};

var colorCount = V3StylePreferences$LiteracyplanetTupperware.allColors.length;

function random(max) {
  return Js_math.floor(Math.random() * max);
}

function randomColor(param) {
  return V3StylePreferences$LiteracyplanetTupperware.allColors[random(colorCount)];
}

function useRandomColor(param) {
  var match = V3StylePreferences$LiteracyplanetTupperware.usePrefs();
  var color = match.color;
  return React.useMemo((function (param) {
                return TailwindMerge.twMerge(color !== undefined ? color : V3StylePreferences$LiteracyplanetTupperware.allColors[random(colorCount)], "PilotQuestionVisible w-screen h-screen grid items-center snap-always snap-center");
              }), [color]);
}

function PilotQuestionVisible$Visible(props) {
  var children = props.children;
  var questionIndex = props.questionIndex;
  var match = V3StylePreferences$LiteracyplanetTupperware.usePrefs();
  var questionZoomInTransition = match.questionZoomInTransition;
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var className = useRandomColor();
  if (match.questionScrolling) {
    return React.createElement(PilotQuestionVisible$ScrollableQuestion, {
                questionZoomInTransition: questionZoomInTransition,
                className: className,
                questionIndex: questionIndex,
                children: React.createElement(PilotQuestionVisible$Content, {
                      questionIndex: questionIndex,
                      children: children
                    })
              });
  } else {
    return React.createElement("div", {
                className: TailwindMerge.twMerge(className, match$1.currentQuestionIndex === questionIndex ? "" : "hidden")
              }, React.createElement("div", undefined, questionZoomInTransition ? React.createElement(PilotQuestionVisible$InViewTransition, {
                          children: React.createElement(PilotQuestionVisible$Content, {
                                questionIndex: questionIndex,
                                children: children
                              })
                        }) : React.createElement(PilotQuestionVisible$Content, {
                          questionIndex: questionIndex,
                          children: children
                        })));
  }
}

var Visible = {
  make: PilotQuestionVisible$Visible
};

function PilotQuestionVisible(props) {
  var children = props.children;
  var questionIndex = props.questionIndex;
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  return React.createElement(V3QuestionsApi$LiteracyplanetTupperware.Provider.make, {
              value: {
                questionIndex: questionIndex
              },
              children: Curry._1(match.isQuestionVisible, questionIndex) ? React.createElement(PilotQuestionVisible$Visible, {
                      questionIndex: questionIndex,
                      visible: true,
                      children: children
                    }) : React.createElement(PilotQuestionVisible$Visible, {
                      questionIndex: questionIndex,
                      visible: false,
                      children: children
                    })
            });
}

var make = PilotQuestionVisible;

export {
  Transition ,
  InViewTransition ,
  scroll ,
  ScrollableQuestion ,
  Content ,
  colorCount ,
  random ,
  randomColor ,
  useRandomColor ,
  Visible ,
  make ,
}
/* react Not a pure module */
